import React, { ReactNode } from 'react'
import { Link } from '@at/design-system-elements'
import { StyledToast, StyledToastDefaultMessage } from './toast.styles'
// import SVG from '@at/react-components-ts/lib/svg/svg'
import { TypeFiesta } from '@at/design-system-foundation'

const DATA_GUI = 'saved-advert-toast'

export type ToastProps = {
    children?: ReactNode
    icon?: ReactNode
    message?: string
    title?: string
    link?: string
    linkText?: string
}

export const Toast = ({ message = '', title = '', icon, children, link, linkText }: ToastProps) => {
    const renderMessage = () => (
        <>
            {title && (
                <TypeFiesta as="h3" id="toast-title">
                    {title}
                </TypeFiesta>
            )}
            <StyledToastDefaultMessage>
                {icon && icon}
                {message && (
                    <TypeFiesta as="p" id="toast-description">
                        {message}
                    </TypeFiesta>
                )}
                {link && linkText && (
                    <Link href={link} rel="external">
                        {linkText}
                    </Link>
                )}
            </StyledToastDefaultMessage>
        </>
    )

    return (
        <StyledToast
            data-gui={DATA_GUI}
            role="log"
            aria-live="polite"
            aria-atomic="true"
            aria-labelledby="toast-title"
            aria-describedby="toast-description"
            data-testid="toast-message"
        >
            {renderMessage()}
            {children}
        </StyledToast>
    )
}
